// #region import
import { ADD_ALERT } from './mutations'
import { LogMethod } from '@/utils'
// #endregion

// #region store
export default {
  namespaced: true,
  // #region state
  state: {
    alerts: [],
  },
  // #endregion
  // #region getters
  getters: {},
  // #endregion
  // #region mutations
  mutations: {
    [ADD_ALERT](state, payload) {
      state.alerts.push(payload)
    },
  },
  // #endregion
  // #region actions
  actions: {
    /**
     * Initialize the Module.
     * @async
     */
    initializeModule() {},
    /**
     * Outputs a message to the web console. The message may be a single string (with optional substitution values), or it may be any one or more JavaScript objects.
     * @param {object} message The message object to log
     * @param {LogMethod} logMethod The log method
     * @async
     */
    log(_, { source, message, logMethod }) {
      console.group('report/log')
      switch (logMethod) {
        case LogMethod.Info:
          console.info(source, message)
          break
        case LogMethod.debug:
          console.debug(source, message)
          break
        case LogMethod.Warning:
          console.warn(source, message)
          break
        case LogMethod.Error:
          console.error(source, message)
          break
        default:
          break
      }
      console.groupEnd()
    },
    /**
     * Outputs an alert to the web interface.
     * @param {Alert} alert The alert to output
     * @async
     */
    alert({ commit }, { alert }) {
      commit(ADD_ALERT, alert.get())
    },
  },
  // #endregion
  // #region modules
  modules: {},
  // #endregion
}
// #endregion
